import { Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from 'recharts';
import type { MonthPoint } from '@shared/types';
import { CHART, tooltipStyle } from './chartTheme';

/** Monthly fill-rate evolution vs the service-level target. */
export function FillRateChart({ data, target = 97, height = 220 }: { data: MonthPoint[]; target?: number; height?: number }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 8, right: 12, left: -12, bottom: 0 }}>
        <CartesianGrid stroke={CHART.grid} vertical={false} />
        <XAxis
          dataKey="month"
          tick={{ fill: CHART.axis, fontSize: CHART.axisFont, fontFamily: CHART.fontFamily }}
          tickLine={false}
          axisLine={{ stroke: CHART.grid }}
        />
        <YAxis
          domain={[88, 100]}
          ticks={[88, 91, 94, 97, 100]}
          tickFormatter={(v) => `${v}%`}
          tick={{ fill: CHART.axis, fontSize: CHART.axisFont, fontFamily: CHART.fontFamily }}
          tickLine={false}
          axisLine={false}
          width={42}
        />
        <Tooltip contentStyle={tooltipStyle} formatter={(v: number) => [`${v}%`, 'Fill Rate']} labelStyle={{ color: '#9CA3AF' }} />
        <ReferenceLine
          y={target}
          stroke={CHART.success}
          strokeDasharray="4 3"
          label={{ value: 'Objetivo', position: 'right', fill: CHART.success, fontSize: 10 }}
        />
        <Line dataKey="value" stroke={CHART.base} strokeWidth={2.5} dot={{ r: 3, fill: CHART.base }} activeDot={{ r: 5 }} />
      </LineChart>
    </ResponsiveContainer>
  );
}
